import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import ContactUs from '../component/Contact/upperSection'

const ContactPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header activeLink={"contact"}/>
    <ContactUs/>
    <Footer/>
    </>
  )
}

export default ContactPage